/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const getStreamRequestHeaders = ({
    apiKey, accessToken, transactionId, apiTimeoutDuration = 0,
}) => {
    const headerObj = {
        Accept: "application/json, text/plain, */*",
    };

    if (apiKey) {
        headerObj["x-api-key"] = apiKey;
    }

    if (accessToken) {
        headerObj.Authorization = accessToken;
    }

    if (transactionId) {
        headerObj["x-transaction-id"] = transactionId;
    }

    if (apiTimeoutDuration) {
        headerObj.Prefer = `respond-partial, wait=${apiTimeoutDuration}`;
    }

    return new Headers(headerObj);
};


const getUploadStreamRequestBody = blb => {
    const formData = new FormData();
    formData.append("contentAnalyzerRequests", `{
        "sensei:engines": [{
          "sensei:execution_info": {
            "sensei:engine": "Annotation:pdf-object-detection:Service-61274bccdf4e4177b62ee988d67b9989"
          },
          "sensei:inputs": {
            "in_stream": {
              "sensei:multipart_field_name": "in_stream",
              "dc:format":"application/pdf+dcxucf"
            }
          },
          "sensei:outputs": {
            "out_stream": {
              "sensei:multipart_field_name": "out_stream",
              "dc:format":"application/zip"
            }
          },
          "sensei:params": {
            "client_analytics_consent":true,
            "result_format":"cnpdf_updates",
            "save_intermediate_files":false,
            "degree_of_parallelism": 1,
            "overrides":"",
            "provisional":true
          }
        }]
      }`);

    formData.append("in_stream", blb);

    return formData;
};

const isInternalErrorResponse = response => {
    if (response && response.headers) {
        return response.headers.get("content-length") !== null;
    }
    return false;
};

export const uploadStream =
    (dataBuffer, resourceUrl, apiKey, transactionId, accessToken) => new Promise((resolve, reject) => {
        const method = "POST";
        const headers = accessToken ?
            getStreamRequestHeaders({ apiKey, accessToken }) :
            getStreamRequestHeaders({ apiKey, transactionId });
        const body = getUploadStreamRequestBody(dataBuffer);

        fetch(resourceUrl, {
            method,
            headers,
            body,
        })
            .then(response => {
                if (!response.ok) {
                    reject(response);
                    return;
                }
                resolve(response);
            })
            .catch(e => {
                reject(e);
            });
    });

export const downloadStream =
    (resourceUrl, apiKey, transactionId, accessToken, apiTimeoutDuration = 59) => new Promise((resolve, reject) => {
        const method = "GET";
        const headers = accessToken ?
            getStreamRequestHeaders({ apiKey, accessToken }) :
            getStreamRequestHeaders({ apiKey, transactionId, apiTimeoutDuration });

        fetch(resourceUrl, {
            method,
            headers,
        })
            .then(response => {
                if (!response.ok) {
                    reject(response);
                    return;
                }
                if (isInternalErrorResponse(response)) {
                    reject(response);
                    return;
                }
                resolve(response.body);
            })
            .catch(e => {
                reject(e);
            });
    });
